import Notification from "../../../components/Common/Notification/index";
import * as customerApi from "../../../services/customer";
import {
  ADD_CUSTOMER_FAILURE,
  ADD_CUSTOMER_REQUEST,
  ADD_CUSTOMER_SUCCESS,
  DELETE_CUSTOMER_FAILURE,
  DELETE_CUSTOMER_REQUEST,
  DELETE_CUSTOMER_SUCCESS,
  GET_CUSTOMERS_FAILURE,
  GET_CUSTOMERS_REQUEST,
  GET_CUSTOMERS_SUCCESS,
  GET_SINGLE_CUSTOMER_FAILURE,
  GET_SINGLE_CUSTOMER_REQUEST,
  GET_SINGLE_CUSTOMER_SUCCESS,
  UPDATE_CUSTOMER_FAILURE,
  UPDATE_CUSTOMER_REQUEST,
  UPDATE_CUSTOMER_SUCCESS,
} from "./customer.actionType";

export const requestAddCustomer = () => {
  return {
    type: ADD_CUSTOMER_REQUEST,
  };
};

export const addCustomerSuccess = (data) => {
  return {
    type: ADD_CUSTOMER_SUCCESS,
    data,
  };
};

export const addCustomerFailure = (message) => {
  return {
    type: ADD_CUSTOMER_FAILURE,
    message,
  };
};

export const addCustomer = (data) => {
  return (dispatch) => {
    dispatch(requestAddCustomer());
    return customerApi
      .addCustomer(data)
      .then((resp) => {
        const data = resp.data;
        dispatch(addCustomerSuccess(data));
        Notification(
          "",
          `${data.name} ग्राहक जोडला गेले.`,
          "success"
        );
        return data.id
      })
      .catch((err) => {
        const errorMessage = err.response && err.response.data.message;
        dispatch(addCustomerFailure());
        Notification("", errorMessage, "error");
        throw errorMessage;
      });
  };
};

export const requestGetCustomers = () => {
  return {
    type: GET_CUSTOMERS_REQUEST,
  };
};

export const getCustomersSuccess = (data) => {
  return {
    type: GET_CUSTOMERS_SUCCESS,
    data,
  };
};

export const getCustomersFailure = (message) => {
  return {
    type: GET_CUSTOMERS_FAILURE,
    message,
  };
};

export const getCustomers = () => {
  return (dispatch) => {
    dispatch(requestGetCustomers());
    return customerApi
      .getCustomers()
      .then(async (resp) => {
        const data = resp.data;
        await dispatch(getCustomersSuccess(data));
        return data;
      })
      .catch((err) => {
        const errorMessage = err.response && err.response.data.message;
        dispatch(getCustomersFailure());
        if (errorMessage === "Invalid token.") {
          return Notification("आपला सांकेतिक माहिती चुकली आहे ", "", "error");
        }
        Notification("", errorMessage, "error");
      });
  };
};

export const requestgetSingleCustomer = () => {
  return {
    type: GET_SINGLE_CUSTOMER_REQUEST,
  };
};

export const getSingleCustomerSuccess = (data) => {
  return {
    type: GET_SINGLE_CUSTOMER_SUCCESS,
    data,
  };
};

export const getSingleCustomerFailure = (message) => {
  return {
    type: GET_SINGLE_CUSTOMER_FAILURE,
    message,
  };
};

export const getSingleCustomer = (id) => {
  return (dispatch) => {
    dispatch(requestgetSingleCustomer());
    return customerApi
      .getSingleCustomer(id)
      .then((resp) => {
        const data = resp.data;
        dispatch(getSingleCustomerSuccess(data));
        return;
      })
      .catch((err) => {
        const errorMessage = err.response && err.response.data;
        dispatch(getSingleCustomerFailure());
        return Notification("", errorMessage, "error");
      });
  };
};

export const requestDeleteCustomer = () => {
  return {
    type: DELETE_CUSTOMER_REQUEST,
  };
};

export const deleteCustomerSuccess = (data) => {
  return {
    type: DELETE_CUSTOMER_SUCCESS,
    data,
  };
};

export const deleteCustomerFailure = (message) => {
  return {
    type: DELETE_CUSTOMER_FAILURE,
    message,
  };
};

export const deleteCustomer = (id) => {
  return (dispatch) => {
    dispatch(requestDeleteCustomer());
    return customerApi
      .deleteCustomer(id)
      .then((resp) => {
        const data = resp.data;
        dispatch(deleteCustomerSuccess(data));
        return Notification(data?.name, `यशस्वीरित्या हटविले गेले.`, "success");
      })
      .catch((err) => {
        const errorMessage =
          (err?.response && err?.response?.data?.message) ||
          "काहीतरी चूक झाली कृपया पुन्हा प्रयत्न करा";
        dispatch(deleteCustomerFailure());
        return Notification("", errorMessage, "error");
      });
  };
};

export const requestUpdateCustomer = () => {
  return {
    type: UPDATE_CUSTOMER_REQUEST,
  };
};

export const updateCustomerSuccess = (data) => {
  return {
    type: UPDATE_CUSTOMER_SUCCESS,
    data,
  };
};

export const updateCustomerFailure = (message) => {
  return {
    type: UPDATE_CUSTOMER_FAILURE,
    message,
  };
};

export const updateCustomer = (id, data) => {
  return (dispatch) => {
    dispatch(requestUpdateCustomer());
    return customerApi
      .updateCustomer(id, data)
      .then((resp) => {
        const data = resp.data;
        dispatch(updateCustomerSuccess(data));
        return Notification(
          "",
          `${data.name} उपडेट केले.`,
          "success"
        );
      })
      .catch((err) => {
        const errorMessage =
          (err?.response && err?.response?.data?.message) ||
          "काहीतरी चूक झाली कृपया पुन्हा प्रयत्न करा";
        dispatch(updateCustomerFailure());
        Notification("", errorMessage, "error");
      });
  };
};
